import React, { Component, useEffect, useState } from "react";
import * as FirestoreService from "../../utils/firebase";

import "./Matches.css";
import Match from "../Match/Match";
const LOADING_TEXT = "Ładowanie...";

export class MatchesList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      matches: [],
      loading: true,
    };
    this.unsubscribe = undefined;
  }

  componentDidMount() {
    console.log("mounted");

    this.unsubscribe = FirestoreService.matchesCollection
      .orderBy("time", "asc")
      .onSnapshot((snapshot) => {
        const newMatches = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        this.setState({
          matches: [...newMatches],
          loading: false,
        });
        //setMatches(newMatches)
      });
  }

  componentWillUnmount() {
    this.unsubscribe();
  }

  render() {
    const matches = this.state.matches;

    const matchesDict = {};
    for (let i = 1; i <= 9; i++) {
      matchesDict[i.toString()] = {
        [`status2`]: [], // active matches
        [`status1`]: [], // not started matches
        [`status0`]: [], // finished matches
      };
    }
    console.log("m", matches)
    matches.forEach((match) => {
      console.log(matchesDict)
      if (match.court) {
        matchesDict[match.court.toString()][
          `status${match.status.toString()}`
        ].push(match);
      }
    });

    return (
      <div className="matches">
        {Object.keys(matchesDict).map((court) => (
          <div className="matches-container">
            <div className="matches-container-title">
              <h1>Kort {court}</h1>
            </div>

            {Object.keys(matchesDict[court]).map((matchStatus) => {
              console.log(matchStatus);
              let matches = matchesDict[court][matchStatus];

              return matches.map((match, index) => {
                return <Match key={index} match={match} />;
              });
            })}
          </div>
        ))}
      </div>
    );
  }
}

export default MatchesList;
